import officeReviewReducer from './officeReviewReducer';

export default officeReviewReducer;
